import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getAdTasks(media, data) {
    return request.get(`/${platform}/ad_tasks/${media}`, data)
}

export function deleteAdTasks(media, ids, data = {}) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/ad_tasks/${media}/${ids}`, data)
}

export function storeOrUpdateAdTask(media, data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/ad_tasks/${media}/${data.id}` : `/${platform}/ad_tasks/${media}`;
    return request[method](url, data)
}

export function shared(data) {
    const url = `/${platform}/ad_tasks/shared/teams`
    return request.post(url, data)
}
